/* WLD — Pro Complete Grooming Guide
   Scroll reveal only. Everything else is CSS.
   Idempotent: safe to load once per page even if several sections request it. */
(function () {
  if (window.__wldRevealInit) return;
  window.__wldRevealInit = true;

  var REDUCED =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(el) {
    el.classList.add('is-in');
  }

  function init() {
    var nodes = document.querySelectorAll('.wld-reveal:not(.is-in)');
    if (!nodes.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) show(nodes[i]);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          show(entry.target);
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    nodes.forEach(function (node, index) {
      // Stagger siblings only, so a long page never accumulates delay.
      var siblingIndex = 0;
      var prev = node.previousElementSibling;
      while (prev && siblingIndex < 6) {
        if (prev.classList.contains('wld-reveal')) siblingIndex++;
        prev = prev.previousElementSibling;
      }
      node.style.setProperty('--d', siblingIndex * 70 + 'ms');
      io.observe(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: sections re-render without a page load.
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(init, 16);
  });
})();

/* ==========================================================================
   DOSE CALCULATOR
   Choosers sum to a starting amount, shown as a fraction. All values come from
   data attributes, so the editor owns the numbers.

   Clicks are handled by ONE capture-phase listener on document. That matters:
   it fires before any other handler on the page, so nothing downstream can
   swallow it, and it works for calculators that appear after load (theme
   editor re-render, or a section injected by an app) without re-initialising.
   ========================================================================== */
(function () {
  if (window.__wldCalcInit) return;
  window.__wldCalcInit = true;

  function frac(n) {
    var whole = Math.floor(n + 1e-9);
    var rem = n - whole;
    var f = '';
    if (Math.abs(rem - 0.25) < 0.01) f = '\u00bc';
    else if (Math.abs(rem - 0.5) < 0.01) f = '\u00bd';
    else if (Math.abs(rem - 0.75) < 0.01) f = '\u00be';
    else if (rem > 0.01) return String(Math.round(n * 100) / 100);
    if (whole === 0) return f || '0';
    return whole + f;
  }

  /* Restart the one-shot animations on the panel.
     Removing the class is not enough on its own — the browser batches style
     changes, so remove + add in the same tick is a no-op. Reading offsetWidth
     in between forces a reflow, which commits the removal and lets the
     re-added class start the animation from frame zero. */
  function pop(panel) {
    if (!panel) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    panel.classList.remove('is-pop');
    void panel.offsetWidth;
    panel.classList.add('is-pop');
  }

  function render(root, animate) {
    var out = root.querySelector('[data-wld-out]');
    if (!out) return;
    var unit = root.querySelector('[data-wld-unit]');
    var panel = root.querySelector('[data-wld-panel]');
    var prompt = root.getAttribute('data-prompt') || '';
    var state = root.__wldState || {};

    var groups = root.querySelectorAll('[data-wld-group]');
    var total = 0;
    var complete = groups.length > 0;
    for (var i = 0; i < groups.length; i++) {
      var key = groups[i].getAttribute('data-wld-group');
      if (typeof state[key] !== 'number') { complete = false; break; }
      total += state[key];
    }

    if (!complete) {
      out.textContent = prompt;
      if (panel) {
        panel.classList.add('wld-result--empty');
        panel.classList.remove('is-pop');
      }
      root.__wldShown = null;
      return;
    }
    if (total < 0) total = 0;
    var text = frac(total);
    var changed = root.__wldShown !== text;
    root.__wldShown = text;

    out.textContent = text;
    if (panel) panel.classList.remove('wld-result--empty');
    if (unit) {
      var one = unit.getAttribute('data-singular');
      var many = unit.getAttribute('data-plural');
      unit.textContent = (total === 1 ? one : many) || unit.textContent;
    }
    /* Only celebrate a value the visitor has not already seen. Re-picking the
       same chip, or a repaint from the theme editor, stays quiet. */
    if (animate && changed) pop(panel);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var btn = t.closest('.wld-chip');
    if (!btn) return;
    var root = btn.closest('[data-wld-calc]');
    var group = btn.closest('[data-wld-group]');
    if (!root || !group) return;

    var key = group.getAttribute('data-wld-group');
    var siblings = group.querySelectorAll('.wld-chip');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].setAttribute('aria-pressed', siblings[i] === btn ? 'true' : 'false');
    }
    if (!root.__wldState) root.__wldState = {};
    root.__wldState[key] = parseFloat(btn.getAttribute('data-val')) || 0;
    render(root, true);
  }, true);

  /* Repaints (first load, theme-editor re-render) never animate — only a real
     click does. */
  function paintAll() {
    var roots = document.querySelectorAll('[data-wld-calc]');
    for (var i = 0; i < roots.length; i++) render(roots[i], false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(paintAll, 16);
  });
})();

/* ==========================================================================
   ENTRY POPUP
   Native <dialog> so focus trapping and Escape come for free.
   ========================================================================== */
(function () {
  if (window.__wldModalInit) return;
  window.__wldModalInit = true;

  function seen(key, days) {
    try {
      if (days <= 0) return false;
      var store = days >= 999 ? window.localStorage : window.sessionStorage;
      var raw = store.getItem(key);
      if (!raw) return false;
      if (days >= 999) return true;
      return Date.now() - parseInt(raw, 10) < days * 86400000;
    } catch (e) { return false; }
  }

  function mark(key, days) {
    try {
      if (days <= 0) return;
      var store = days >= 999 ? window.localStorage : window.sessionStorage;
      store.setItem(key, String(Date.now()));
    } catch (e) {}
  }

  function initOne(dlg) {
    if (dlg.__wldReady || typeof dlg.showModal !== 'function') return;
    dlg.__wldReady = true;

    var key = 'wld-popup-' + (dlg.getAttribute('data-key') || dlg.id);
    var days = parseInt(dlg.getAttribute('data-frequency') || '0', 10);
    var delay = parseInt(dlg.getAttribute('data-delay') || '0', 10);
    var editor = document.documentElement.classList.contains('shopify-design-mode') ||
      (window.Shopify && window.Shopify.designMode);

    dlg.querySelectorAll('[data-wld-close]').forEach(function (b) {
      b.addEventListener('click', function () { dlg.close(); });
    });

    // Click on the backdrop (outside the card) closes it.
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) dlg.close();
    });
    dlg.addEventListener('close', function () { mark(key, days); });

    if (!editor && seen(key, days)) return;

    window.setTimeout(function () {
      if (!dlg.open && document.body.contains(dlg)) {
        try { dlg.showModal(); } catch (e) {}
      }
    }, Math.max(0, delay));
  }

  function init() { document.querySelectorAll('[data-wld-modal]').forEach(initOne); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { window.setTimeout(init, 16); });
})();

/* ==========================================================================
   TWO-STEP SIGN-UP
   Pick a product, then give an email. The choice rides along as a profile
   property so Klaviyo can segment on it and send the matching guide.
   Posts to Klaviyo's client subscriptions endpoint, which is designed for
   public browser use and takes the PUBLIC key only.
   ========================================================================== */
(function () {
  if (window.__wldSignupInit) return;
  window.__wldSignupInit = true;

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function initOne(form) {
    if (form.__wldReady) return;
    form.__wldReady = true;

    var chips = form.querySelectorAll('[data-wld-choice]');
    var hidden = form.querySelector('[data-wld-choice-value]');
    var mail = form.querySelector('[data-wld-step="mail"]');
    var pick = form.querySelector('[data-wld-step="pick"]');
    var done = form.querySelector('[data-wld-done]');
    var err = form.querySelector('[data-wld-err]');
    var input = form.querySelector('input[type="email"]');
    var submit = form.querySelector('button[type="submit"]');

    function fail(message) {
      if (!err) return;
      err.textContent = message;
      err.hidden = false;
    }

    function clearError() {
      if (err) err.hidden = true;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        if (hidden) hidden.value = chip.getAttribute('data-value') || '';
        clearError();
        if (mail) {
          mail.hidden = false;
          // Only steal focus once, so re-picking does not yank the cursor
          // out of a half-typed address.
          if (!form.__wldRevealed) {
            form.__wldRevealed = true;
            if (input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
          }
        }
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var email = (input && input.value || '').trim();
      if (!EMAIL.test(email)) {
        fail('Please enter a valid email address.');
        if (input) input.focus();
        return;
      }

      var company = form.getAttribute('data-company') || '';
      var list = form.getAttribute('data-list') || '';
      if (!company || !list) {
        fail(form.getAttribute('data-error') || 'This form is not connected yet.');
        return;
      }

      var props = {};
      var choice = hidden && hidden.value;
      if (choice) props[form.getAttribute('data-prop') || 'Product Owned'] = choice;

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.getAttribute('data-source') || 'Popup',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email, properties: props }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      };

      if (submit) { submit.disabled = true; submit.setAttribute('aria-busy', 'true'); }

      window.fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: form.getAttribute('data-revision') || '2026-07-15'
        },
        body: JSON.stringify(payload)
      }).then(function (res) {
        // A successful subscribe answers 202 with an empty body.
        if (!res.ok) throw new Error('HTTP ' + res.status);
        if (pick) pick.hidden = true;
        if (mail) mail.hidden = true;
        if (done) done.hidden = false;
      }).catch(function () {
        fail(form.getAttribute('data-error') || 'Something went wrong. Please try again.');
      }).then(function () {
        if (submit) { submit.disabled = false; submit.removeAttribute('aria-busy'); }
      });
    });
  }

  function init() { document.querySelectorAll('[data-wld-signup]').forEach(initOne); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { window.setTimeout(init, 16); });
})();

/* ==========================================================================
   WHERE TO APPLY — body map
   Every area block renders twice: a button in the list and a zone on the
   photo, paired by data-wld-area / data-wld-zone.

   One capture-phase listener per event type on document, same as the
   calculator: it survives sections injected after load and cannot be
   swallowed by a handler further down the tree.

   The idle cycle runs on a timer and stops for good the first time the
   visitor touches anything, so it never fights them for control.
   ========================================================================== */
(function () {
  if (window.__wldMapInit) return;
  window.__wldMapInit = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setActive(map, index) {
    var i, el;
    var zones = map.querySelectorAll('[data-wld-zone]');
    var pins = map.querySelectorAll('[data-wld-pin]');
    var items = map.querySelectorAll('[data-wld-area]');

    for (i = 0; i < zones.length; i++) {
      el = zones[i];
      el.classList.toggle('is-on', el.getAttribute('data-wld-zone') === index);
    }
    for (i = 0; i < pins.length; i++) {
      el = pins[i];
      el.classList.toggle('is-on', el.getAttribute('data-wld-pin') === index);
    }
    var hits = map.querySelectorAll('[data-wld-hit]');
    for (i = 0; i < hits.length; i++) {
      el = hits[i];
      el.classList.toggle('is-on', el.getAttribute('data-wld-hit') === index);
    }
    for (i = 0; i < items.length; i++) {
      el = items[i];
      el.setAttribute('aria-pressed', el.getAttribute('data-wld-area') === index ? 'true' : 'false');
    }
    /* Once anything is active the resting wash is dropped, so the chosen area
       is the only one carrying colour. */
    map.classList.toggle('is-active', !!index);
    map.__wldOn = index || null;
  }

  function stopCycle(map) {
    if (map.__wldTimer) {
      window.clearInterval(map.__wldTimer);
      map.__wldTimer = null;
    }
    map.__wldTouched = true;
  }

  function startCycle(map) {
    if (REDUCED || map.__wldTouched || map.__wldTimer) return;
    if (map.getAttribute('data-cycle') !== 'true') return;
    var items = map.querySelectorAll('[data-wld-area]');
    if (items.length < 2) return;
    var ms = parseInt(map.getAttribute('data-cycle-ms'), 10) || 3000;
    var n = 0;
    map.__wldTimer = window.setInterval(function () {
      if (!document.body.contains(map)) { stopCycle(map); return; }
      n = (n % items.length) + 1;
      setActive(map, String(n));
    }, ms);
  }

  function mapOf(el) {
    return el && typeof el.closest === 'function' ? el.closest('[data-wld-map]') : null;
  }

  /* An area can be driven from two places: the label beside the photo, and the
     invisible hit area over the body part itself. Both carry the same index,
     so everything downstream treats them identically. */
  function triggerOf(el) {
    if (!el || typeof el.closest !== 'function') return null;
    return el.closest('[data-wld-area]') || el.closest('[data-wld-hit]');
  }
  function indexOf(el) {
    return el.getAttribute('data-wld-area') || el.getAttribute('data-wld-hit');
  }

  /* Pointer. mouseover/mouseout rather than mouseenter so one delegated
     listener covers every button. */
  document.addEventListener('mouseover', function (e) {
    var btn = triggerOf(e.target);
    if (!btn) return;
    var map = mapOf(btn);
    if (!map) return;
    stopCycle(map);
    setActive(map, indexOf(btn));
  }, true);

  document.addEventListener('mouseout', function (e) {
    var btn = triggerOf(e.target);
    if (!btn) return;
    var map = mapOf(btn);
    if (!map) return;
    /* Moving between two triggers fires mouseout before the next mouseover, and
       moving from a label to its hit area (or back) must not flicker either.
       Only clear when the pointer has genuinely left every trigger. */
    var to = e.relatedTarget;
    if (to && to.closest && to.closest('[data-wld-map]') === map && triggerOf(to)) return;
    if (map.__wldPinned) return;
    setActive(map, null);
  }, true);

  /* Keyboard: tabbing through the list drives the map too. */
  document.addEventListener('focusin', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-wld-area]') : null;
    if (!btn) return;
    var map = mapOf(btn);
    if (!map) return;
    stopCycle(map);
    setActive(map, btn.getAttribute('data-wld-area'));
  }, true);

  /* Tap / click pins the area so it survives the finger lifting. Tapping the
     same one again releases it. */
  document.addEventListener('click', function (e) {
    var btn = triggerOf(e.target);
    if (!btn) return;
    var map = mapOf(btn);
    if (!map) return;
    e.preventDefault();
    stopCycle(map);
    var idx = indexOf(btn);
    if (map.__wldPinned === idx) {
      map.__wldPinned = null;
      setActive(map, null);
    } else {
      map.__wldPinned = idx;
      setActive(map, idx);
    }
  }, true);

  function initAll() {
    var maps = document.querySelectorAll('[data-wld-map]');
    for (var i = 0; i < maps.length; i++) {
      var map = maps[i];
      if (map.__wldReady) continue;
      map.__wldReady = true;
      map.__wldTouched = false;
      map.__wldPinned = null;
      startCycle(map);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(initAll, 16);
  });
})();

/* ==========================================================================
   VIDEO FACADE
   A YouTube or Vimeo embed costs hundreds of kilobytes and a pile of
   third-party cookies before anyone decides to watch. So the poster and a
   play button stand in, and the iframe is built on the first click.
   ========================================================================== */
(function () {
  if (window.__wldEmbedInit) return;
  window.__wldEmbedInit = true;

  function initOne(box) {
    if (box.__wldReady) return;
    box.__wldReady = true;

    var btn = box.querySelector('[data-wld-play]');
    var src = box.getAttribute('data-src') || '';
    if (!btn || !src) return;

    btn.addEventListener('click', function () {
      var frame = document.createElement('iframe');
      frame.className = 'wld-vid__frame';
      frame.setAttribute('src', src);
      frame.setAttribute('title', box.getAttribute('data-title') || 'Video');
      frame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
      frame.setAttribute('allowfullscreen', '');
      frame.setAttribute('loading', 'lazy');
      box.innerHTML = '';
      box.appendChild(frame);
      box.classList.add('wld-vid--playing');
    });
  }

  function init() { document.querySelectorAll('[data-wld-embed]').forEach(initOne); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { window.setTimeout(init, 16); });
})();